import Controller, { OnBeforeSubmit, OnClick, OnMount, OnUnmount, OnValidate } from '@philips-internal/oswald-ui-core/lib/client';
import { ActionAPI, FormAPI, InputAPI, ModalProps, ModalService,  RadioGroupAPI, SelectableItem, ToastService, WizardAPI} from '@philips-internal/oswald-ui-components';
import BaseController from '../../../BaseController';
import { FragmentNames, ScoreNasEditAliases } from '../../../../codegen/index';
import moment from 'moment';
import { ISO_FULL_DATE_FORMAT } from '../../../../constants/date-utils';
import timeService from '../../../../services/time-service';
import { Inject } from '@odinjs/odin';
import InformationBarUtils from '../../../commons/header/information-bar-header-utils';
import { ValidateEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { applicationContext, foundationContext } from '@philips-internal/oswald-ui-foundation';
import { Value } from '@philips-internal/oswald-ui-core';
import { HttpService, } from '@philips-internal/oswald-ui-core/lib/services';
import { Endpoint } from '../../../../constants/endpoints';
import { Placement, ToastLevel, ToastType } from '@philips-internal/oswald-ui-constants';
import { generateUUID } from '@philips-internal/oswald-ui-utils';
import { HealthProfessionalUser } from '../../../../app/authentication';
import { DomainType, RadioGroupData, ScoreNASResponse } from '../../score-types';
import { ApplicationRoute } from '../../../../constants/routes';
import { ScoreListContext } from '../../scores-list/scores-list-service';
import { ScoreType } from '../../scores-references/score-reference-controller';
import { radioExpressionData } from '../radio-group-data/expression-yes-no';
import { LocatorTypes } from '../../../locator/locator-controller';
import DialogService from '../../../../services/dialog-service';
import { BooleanUtils } from '../../../../utils/boolean-utils';
import { RadioGroupExpressions } from '../radio-group-data/radio-group-expressions';
import { WizardSteps } from '../../../../constants/wizards';

interface ResponseCreateScoreNAS {
  dtEvaluation: string;
  idScoreIndexes: number;
  nrAttendance?: number;
  time?: number;
  updateDate?: string;
  updateNrec?: string;
  username?: string;
  usuarioNREC?: string;
}

type RadioGroup = {
  field: RadioGroupAPI
  props: string
}

@Controller({ component: ScoreNasEditAliases.SCORE_NAS_ADD_LAYOUT, fragment: FragmentNames.SCORE_NAS_EDIT })
export default class ScoreNasEditController extends BaseController {

  @Inject(ScoreNasEditAliases.INPUT_SETUP_DATE)
  private setupDateInputApi!: InputAPI;

  @Inject(ScoreNasEditAliases.FORM_ONE)
  private formOneScoreNasCreateAPI!: FormAPI;

  @Inject(ScoreNasEditAliases.FORM_TWO)
  private formTwoScoreNasCreateAPI!: FormAPI;

  @Inject(ScoreNasEditAliases.FORM_THREE)
  private formThreeScoreNasCreateAPI!: FormAPI;

  @Inject(ScoreNasEditAliases.FORM_FOUR)
  private formFourScoreNasCreateAPI!: FormAPI;

  @Inject(ScoreNasEditAliases.FORM_FIVE)
  private formFiveScoreNasCreateAPI!: FormAPI;

  @Inject(ScoreNasEditAliases.FORM_SIX)
  private formSixScoreNasCreateAPI!: FormAPI;

  @Inject(ScoreNasEditAliases.WIZARD)
  private wizard!: WizardAPI;

  @Inject(ScoreNasEditAliases.ACTION_DELETE_SCORE_NAS)
  private actionDeleteAPI!: ActionAPI;

  @Inject(ScoreNasEditAliases.ACTION_NEW_SCORE_NAS)
  private actionNewAPI!: ActionAPI;

  @Inject(ScoreNasEditAliases.ACTION_REFERENCE_SCORE_NAS)
  private actionReferenceAPI!: ActionAPI;

  @Inject(ScoreNasEditAliases.ACTION_RELEASE_SCORE_NAS)
  private actionReleaseAPI!: ActionAPI;

  @Inject(ScoreNasEditAliases.RADIO_GROUP_MONITORING_CONTROL_A)
  private radioGroupMonitoringControlA!: RadioGroupAPI;

  @Inject(ScoreNasEditAliases.RADIO_GROUP_MONITORING_CONTROL_B)
  private radioGroupMonitoringControlB!: RadioGroupAPI;

  @Inject(ScoreNasEditAliases.RADIO_GROUP_MONITORING_CONTROL_C)
  private radioGroupMonitoringControlC!: RadioGroupAPI;

  @Inject(ScoreNasEditAliases.RADIO_GROUP_MOBILITY_A)
  private radioGroupMobilityA!: RadioGroupAPI;

  @Inject(ScoreNasEditAliases.RADIO_GROUP_MOBILITY_B)
  private radioGroupMobilityB!: RadioGroupAPI;

  @Inject(ScoreNasEditAliases.RADIO_GROUP_MOBILITY_C)
  private radioGroupMobilityC!: RadioGroupAPI;

  @Inject(ScoreNasEditAliases.RADIO_GROUP_ADMIN_TASKS_A)
  private radioGroupAdminTasksA!: RadioGroupAPI;

  @Inject(ScoreNasEditAliases.RADIO_ADMIN_TASKS_B)
  private radioGroupAdminTasksB!: RadioGroupAPI;

  @Inject(ScoreNasEditAliases.RADIO_ADMIN_TASKS_C)
  private radioGroupAdminTasksC!: RadioGroupAPI;

  @Inject(ScoreNasEditAliases.RADIO_GROUP_HYGIENE_A)
  private radioGroupHygieneA!: RadioGroupAPI;

  @Inject(ScoreNasEditAliases.RADIO_GROUP_HYGIENE_B)
  private radioGroupHygieneB!: RadioGroupAPI;

  @Inject(ScoreNasEditAliases.RADIO_GROUP_HYGIENE_C)
  private radioGroupHygieneC!: RadioGroupAPI;

  @Inject(ScoreNasEditAliases.RADIO_GROUP_DRAIN)
  private radioGroupDrain!: RadioGroupAPI;

  @Inject(ScoreNasEditAliases.RADIO_GROUP_SUPPORT_CARDIO_A)
  private radioGroupSupportCardioA!: RadioGroupAPI;

  @Inject(ScoreNasEditAliases.RADIO_SUPPORT_CARDIO_B)
  private radioGroupSupportCardioB!: RadioGroupAPI;

  @Inject(ScoreNasEditAliases.RADIO_SUPPORT_CARDIO_C)
  private radioGroupSupportCardioC!: RadioGroupAPI;

  @Inject(ScoreNasEditAliases.RADIO_SUPPORT_CARDIO_D)
  private radioGroupSupportCardioD!: RadioGroupAPI;

  @Inject(ScoreNasEditAliases.RADIO_SUPPORT_A)
  private radioGroupSupportA!: RadioGroupAPI;

  @Inject(ScoreNasEditAliases.RADIO_SUPPORT_B)
  private radioGroupSupportB!: RadioGroupAPI;

  @Inject(ScoreNasEditAliases.RADIO_GROUP_LABORATORY_INVESTIGATION_A)
  private radioGroupLaboratory!: RadioGroupAPI;

  @Inject(ScoreNasEditAliases.RADIO_GROUP_MEDICATION)
  private radioGroupMedication!: RadioGroupAPI;

  @Inject(ScoreNasEditAliases.RADIO_SUPPORT_VENTILATORY_A)
  private radioGroupSupportVentilatoryA!: RadioGroupAPI;

  @Inject(ScoreNasEditAliases.RADIO_SUPPORT_VENTILATORY_B)
  private radioGroupSupportVentilatoryB!: RadioGroupAPI;

  @Inject(ScoreNasEditAliases.RADIO_SUPPORT_VENTILATORY_C)
  private radioGroupSupportVentilatoryC!: RadioGroupAPI;

  @Inject(ScoreNasEditAliases.RADIO_GROUP_RENAL_SUPPORT_A)
  private radioGroupRenalSupportA!: RadioGroupAPI;

  @Inject(ScoreNasEditAliases.RADIO_GROUP_RENAL_SUPPORT_B)
  private radioGroupRenalSupportB!: RadioGroupAPI;

  @Inject(ScoreNasEditAliases.RADIO_GROUP_NEUROLOGIC_SUPPORT)
  private radioGroupNeurologicSupport!: RadioGroupAPI;

  @Inject(ScoreNasEditAliases.RADIO_GROUP_METABOLIC_SUPPORT_A)
  private radioGroupMetabolicSupportA!: RadioGroupAPI;

  @Inject(ScoreNasEditAliases.RADIO_GROUP_METABOLIC_SUPPORT_B)
  private radioGroupMetabolicSupportB!: RadioGroupAPI;

  @Inject(ScoreNasEditAliases.RADIO_GROUP_METABOLIC_SUPPORT_C)
  private radioGroupMetabolicSupportC!: RadioGroupAPI;

  @Inject(ScoreNasEditAliases.RADIO_GROUP_SPECIAL_INTERVETIONS_A)
  private radioGroupSpecialIntervetionsA!: RadioGroupAPI;

  @Inject(ScoreNasEditAliases.RADIO_GROUP_SPECIAL_INTERVETIONS_B)
  private radioGroupSpecialIntervetionsB!: RadioGroupAPI;

  @OnValidate(ScoreNasEditAliases.FORM_ONE)
  handleOnValidate(validation: ValidateEvent): void {
    this.wizard.setStepDone(WizardSteps.STEP_ONE, validation.valid);
  }

  @OnValidate(ScoreNasEditAliases.FORM_TWO)
  handleOnSecondValidate(validation: ValidateEvent): void {
    this.wizard.setStepDone(WizardSteps.STEP_TWO, validation.valid);
  }

  @OnValidate(ScoreNasEditAliases.FORM_THREE)
  handleOnTirdValidate(validation: ValidateEvent): void {
    this.wizard.setStepDone(WizardSteps.STEP_THREE, validation.valid);
  }

  @OnValidate(ScoreNasEditAliases.FORM_FOUR)
  handleOnFourthValidate(validation: ValidateEvent): void {
    this.wizard.setStepDone(WizardSteps.STEP_FOUR, validation.valid);
  }

  @OnValidate(ScoreNasEditAliases.FORM_FIVE)
  handleOnFigthValidate(validation: ValidateEvent): void {
    this.wizard.setStepDone(WizardSteps.STEP_FIVE, validation.valid);
  }

  @OnValidate(ScoreNasEditAliases.FORM_SIX)
  handleOnSixValidate(validation: ValidateEvent): void {
    this.wizard.setStepDone(WizardSteps.STEP_SIX, validation.valid);
  }

  @OnMount({ target: ScoreNasEditAliases.FORM_ONE })
  handleFormMount(): void {
    ScoreListContext.currentTab = ScoreType.SCORE_NAS
    const { idScoreIndexes, encounterId, patientId } = this.historyService.getCurrentRouteParams();
    const idScoreNas = Number(idScoreIndexes)
    this.setRadioButtonData(idScoreNas);
    InformationBarUtils.collapsedBar = true;
    this.context.set({ encounterId, locator: LocatorTypes.PROFESSIONAL_PERSON, patientId });
  }

  @OnUnmount({ target: ScoreNasEditAliases.FORM_ONE })
  handleUnMountForm(): void {
    this.clearAbortController();
  }

  @OnMount({target: ScoreNasEditAliases.INPUT_SETUP_DATE})
  handleInputMount(): void {
    timeService.getCurrentDateTime(this.setAbortController())
      .then(date => this.setupDateInputApi.setValue(date))
      .catch(() => this.setupDateInputApi.setValue(moment().format(ISO_FULL_DATE_FORMAT)))
  }

  private showModalSubmit(idScore: number): void {
    DialogService.open({
      descriptionDialog: 'patient-evolution.release-title-evolution',
      onClickCancel: () => { this.goBack() },
      onClickOk: async () => { await this.releaseNASScore(idScore) },
      titleDialog: 'patient-evolution.release-evolution',
      titleOnCancel: 'patient-evolution.release-cancel-evolution',
      titleOnOk: 'patient-evolution.release-submit-evolution',
    });
  }

  private showToast(message: string, level: ToastLevel): void {
    ToastService.open({
      dismissible: true,
      highlight: false,
      id: 'score-nas-create',
      level,
      message,
      placement: Placement.BOTTOM,
      showIcon: true,
      timeout: 5000,
      type: ToastType.BANNER,
    })
  }

  private goBack(): void {
    applicationContext.popNavigationItem();
    applicationContext.popNavigationItem();
  }

  private loadEditionData(radioGroupArray: RadioGroup[], record: ScoreNASResponse): void {
    this.formOneScoreNasCreateAPI.setEditing(true);
    this.formOneScoreNasCreateAPI.validate();
    this.formOneScoreNasCreateAPI.setDisabled(true);

    this.formOneScoreNasCreateAPI.setData({...record, time: record.hour });
    this.setupDateInputApi.setValue(record.dtEvaluation)

    radioGroupArray.forEach((radioGroup) => {
      radioGroup.field?.setData(radioExpressionData)
      Object.keys(record).map((key) => {
        if (key === radioGroup.props) {
          const value = record[key as keyof typeof record] === 'N' ? 0 : 1
          radioGroup.field?.setValue(radioExpressionData[value])
          this.formOneScoreNasCreateAPI.setData({...this.formOneScoreNasCreateAPI.getData(), [key]: radioExpressionData[value]})
          this.formTwoScoreNasCreateAPI.setData({...this.formTwoScoreNasCreateAPI.getData(), [key]: radioExpressionData[value]})
          this.formThreeScoreNasCreateAPI.setData({...this.formThreeScoreNasCreateAPI.getData(), [key]: radioExpressionData[value]})
          this.formFourScoreNasCreateAPI.setData({...this.formFourScoreNasCreateAPI.getData(), [key]: radioExpressionData[value]})
          this.formFiveScoreNasCreateAPI.setData({...this.formFiveScoreNasCreateAPI.getData(), [key]: radioExpressionData[value]})
          this.formSixScoreNasCreateAPI.setData({...this.formSixScoreNasCreateAPI.getData(), [key]: radioExpressionData[value]})
        }
      })
    })

    this.wizard.setStepDone(WizardSteps.STEP_ONE, true);
    this.wizard.setStepDone(WizardSteps.STEP_TWO, true);
    this.wizard.setStepDone(WizardSteps.STEP_THREE, true);
    this.wizard.setStepDone(WizardSteps.STEP_FOUR, true);
    this.wizard.setStepDone(WizardSteps.STEP_FIVE, true);
    this.wizard.setStepDone(WizardSteps.STEP_SIX, true);
  }

  private releaseNASScore(sequenceNumber: number): void {
    this.formOneScoreNasCreateAPI.setLoading(true);
    const abortController = this.setAbortController();
    HttpService.put(Endpoint.RELEASE_SCORE_NAS, { sequenceNumber }, { abortController })
      .then(() => {
        applicationContext.popNavigationItem();
      }).catch((err) => {
        this.showToast(err?.body.errorMessage, ToastLevel.ERROR);
      }).finally(() => this.formOneScoreNasCreateAPI.setLoading(false));
  }

  private createNewNASScore(body: Record<string, Value>): void {
    this.formOneScoreNasCreateAPI.setLoading(true);
    const abortController = this.setAbortController();
    HttpService.post(Endpoint.POST_CREATE_SCORE_NAS, undefined, { abortController, body })
      .then(response => {
        const { idScoreIndexes } = response.body as ResponseCreateScoreNAS;
        this.context.set({ idScoreIndexes, isCreated: true });
        this.showModalSubmit( idScoreIndexes as number);
      })
      .catch((err) => {
        this.showToast(err?.body.errorMessage, ToastLevel.ERROR);
      }).finally(() => this.formOneScoreNasCreateAPI.setLoading(false));
  }

  private delete(sequenceNumber: number): void {
    this.formOneScoreNasCreateAPI.setLoading(true);
    const abortController = this.setAbortController();
    HttpService.delete(Endpoint.SCORE_NAS, {
      sequenceNumber
    }, { abortController }).then(() => {
      applicationContext.popNavigationItem();
    }).catch((err) => {
      this.showToast(err?.body.errorMessage, ToastLevel.ERROR);
    }).finally(() => this.formOneScoreNasCreateAPI.setLoading(false));
  }

  private confirmDelete(idScore: number): void {
    DialogService.open({
      descriptionDialog: 'patient-evolution.delete-question-evolution',
      onClickCancel: () => { applicationContext.popNavigationItem() },
      onClickOk: () => { this.delete(idScore) },
      titleDialog: 'patient-evolution.delete-question-evolution',
      titleOnCancel: 'tws.form.cancel',
      titleOnOk: 'patient-evolution.delete-evolution',
    });
  }

  private setRadioButtonData(sequenceNumberNas: number): void {
    const radioGroupArray: RadioGroupData[] = this.getRadioGroupArray()
    if (!isNaN(sequenceNumberNas as number)) {
      applicationContext.popNavigationItem();
      this.formOneScoreNasCreateAPI.setLoading(true);
      this.fetchNasScores(sequenceNumberNas, radioGroupArray)
    } else {
      this.actionDeleteAPI.setEnabled(false)
      this.actionNewAPI.setEnabled(false);
      this.actionReferenceAPI.setEnabled(false);
      this.actionReleaseAPI.setEnabled(false);
      radioGroupArray.forEach((radioGroup) => {
        radioGroup.field?.setData(radioExpressionData);
        radioGroup.field?.setValue(radioExpressionData[0]);
      })
    }
  }

  private fetchNasScores(sequenceNumber: number, radioGroupArray: RadioGroupData[]): Promise<void> {
    return HttpService.get(Endpoint.SCORE_NAS, { sequenceNumber })
      .then(res => {
        const record = res.body as ScoreNASResponse;
        this.loadEditionData(radioGroupArray, record);
      }).finally(() => this.formOneScoreNasCreateAPI.setLoading(false))
  }

  @OnBeforeSubmit({ target: ScoreNasEditAliases.WIZARD })
  handleBeforeSubmit(): void {
    const { encounterId, idScoreIndexes } = this.historyService.getCurrentRouteParams();
    const isCreated = this.context.get('isCreated');
    if (isCreated) {
      this.showModalSubmit(idScoreIndexes as number);
      return;
    }
    const formDataOne = this.formOneScoreNasCreateAPI.getRecord();
    const formDataTwo = this.formTwoScoreNasCreateAPI.getRecord();
    const formDataFour = this.formFourScoreNasCreateAPI.getRecord();
    const formDataThree = this.formThreeScoreNasCreateAPI.getRecord();
    const formDataFive = this.formFiveScoreNasCreateAPI.getRecord();
    const formDataSix = this.formSixScoreNasCreateAPI.getRecord();

    const dtEvaluation = moment(formDataOne.dtEvaluation as string).utc().format(ISO_FULL_DATE_FORMAT);
    const hour =  String((formDataOne.time as DomainType).valueDomain);

    const descriptionItem1a = formDataOne.descriptionItem1a as SelectableItem;
    const descriptionItem1b = formDataOne.descriptionItem1b as SelectableItem;
    const descriptionItem1c = formDataOne.descriptionItem1c as SelectableItem;
    const descriptionItem2  = formDataOne.descriptionItem2 as SelectableItem;

    const descriptionItem3  = formDataTwo.descriptionItem3 as SelectableItem;
    const descriptionItem4a = formDataTwo.descriptionItem4a as SelectableItem;
    const descriptionItem4b = formDataTwo.descriptionItem4b as SelectableItem;
    const descriptionItem4c = formDataTwo.descriptionItem4c as SelectableItem;
    const descriptionItem5  = formDataTwo.descriptionItem5 as SelectableItem;

    const descriptionItem6a = formDataThree.descriptionItem6a as SelectableItem;
    const descriptionItem6b = formDataThree.descriptionItem6b as SelectableItem;
    const descriptionItem6c = formDataThree.descriptionItem6c as SelectableItem;
    const descriptionItem7a = formDataThree.descriptionItem7a as SelectableItem;
    const descriptionItem7b = formDataThree.descriptionItem7b as SelectableItem;

    const descriptionItem8a = formDataFour.descriptionItem8a as SelectableItem;
    const descriptionItem8b = formDataFour.descriptionItem8b as SelectableItem;
    const descriptionItem8c = formDataFour.descriptionItem8c as SelectableItem;
    const descriptionItem9  = formDataFour.descriptionItem9 as SelectableItem;
    const descriptionItem10 = formDataFour.descriptionItem10 as SelectableItem;
    const descriptionItem11 = formDataFour.descriptionItem11 as SelectableItem;

    const descriptionItem12 = formDataFive.descriptionItem12 as SelectableItem;
    const descriptionItem13 = formDataFive.descriptionItem13 as SelectableItem;
    const descriptionItem14 = formDataFive.descriptionItem14 as SelectableItem;
    const descriptionItem15 = formDataFive.descriptionItem15 as SelectableItem;
    const descriptionItem16 = formDataFive.descriptionItem16 as SelectableItem;
    const descriptionItem17 = formDataFive.descriptionItem17 as SelectableItem;
    const descriptionItem18 = formDataFive.descriptionItem18 as SelectableItem;

    const descriptionItem19 = formDataSix.descriptionItem19 as SelectableItem;
    const descriptionItem20 = formDataSix.descriptionItem20 as SelectableItem;
    const descriptionItem21 = formDataSix.descriptionItem21 as SelectableItem;
    const descriptionItem22 = formDataSix.descriptionItem22 as SelectableItem;
    const descriptionItem23 = formDataSix.descriptionItem23 as SelectableItem;

    const user = foundationContext.getUser() as unknown as HealthProfessionalUser;
    const sequenceNumberNas= Number.isNaN(parseInt(idScoreIndexes as string)) ? null : idScoreIndexes as number;
    const body = {
      descriptionItem1a: BooleanUtils.numberIsPositiveValue(descriptionItem1a?.value),
      descriptionItem1b: BooleanUtils.numberIsPositiveValue(descriptionItem1b?.value),
      descriptionItem1c: BooleanUtils.numberIsPositiveValue(descriptionItem1c?.value),
      descriptionItem2:  BooleanUtils.numberIsPositiveValue(descriptionItem2?.value),
      descriptionItem3:  BooleanUtils.numberIsPositiveValue(descriptionItem3?.value),
      descriptionItem4a: BooleanUtils.numberIsPositiveValue(descriptionItem4a?.value),
      descriptionItem4b: BooleanUtils.numberIsPositiveValue(descriptionItem4b?.value),
      descriptionItem4c: BooleanUtils.numberIsPositiveValue(descriptionItem4c?.value),
      descriptionItem5:  BooleanUtils.numberIsPositiveValue(descriptionItem5?.value),
      descriptionItem6a: BooleanUtils.numberIsPositiveValue(descriptionItem6a?.value),
      descriptionItem6b: BooleanUtils.numberIsPositiveValue(descriptionItem6b?.value),
      descriptionItem6c: BooleanUtils.numberIsPositiveValue(descriptionItem6c?.value),
      descriptionItem7a: BooleanUtils.numberIsPositiveValue(descriptionItem7a?.value),
      descriptionItem7b: BooleanUtils.numberIsPositiveValue(descriptionItem7b?.value),
      descriptionItem8a: BooleanUtils.numberIsPositiveValue(descriptionItem8a?.value),
      descriptionItem8b: BooleanUtils.numberIsPositiveValue(descriptionItem8b?.value),
      descriptionItem8c: BooleanUtils.numberIsPositiveValue(descriptionItem8c?.value),
      descriptionItem9:  BooleanUtils.numberIsPositiveValue(descriptionItem9?.value),
      descriptionItem10: BooleanUtils.numberIsPositiveValue(descriptionItem10?.value),
      descriptionItem11: BooleanUtils.numberIsPositiveValue(descriptionItem11?.value),
      descriptionItem12: BooleanUtils.numberIsPositiveValue(descriptionItem12?.value),
      descriptionItem13: BooleanUtils.numberIsPositiveValue(descriptionItem13?.value),
      descriptionItem14: BooleanUtils.numberIsPositiveValue(descriptionItem14?.value),
      descriptionItem15: BooleanUtils.numberIsPositiveValue(descriptionItem15?.value),
      descriptionItem16: BooleanUtils.numberIsPositiveValue(descriptionItem16?.value),
      descriptionItem17: BooleanUtils.numberIsPositiveValue(descriptionItem17?.value),
      descriptionItem18: BooleanUtils.numberIsPositiveValue(descriptionItem18?.value),
      descriptionItem19: BooleanUtils.numberIsPositiveValue(descriptionItem19?.value),
      descriptionItem20: BooleanUtils.numberIsPositiveValue(descriptionItem20?.value),
      descriptionItem21: BooleanUtils.numberIsPositiveValue(descriptionItem21?.value),
      descriptionItem22: BooleanUtils.numberIsPositiveValue(descriptionItem22?.value),
      descriptionItem23: BooleanUtils.numberIsPositiveValue(descriptionItem23?.value),
      dtEvaluation,
      hour,
      idScoreIndexes: sequenceNumberNas,
      nrAttendance: encounterId as number,
      professionalCode: user.physicalPersonId,
    } as Record<string, Value>;
    this.createNewNASScore(body);
  }

  private getReference(): void {
    const scoreType = 'nas';
    const modalProperties: ModalProps = {
      closeable: true,
      closeByDocument: false,
      closeByEscape: false,
      focusOnOpen: false,
      fragment: 'score-reference',
      id: 'score-reference',
      onCancel: () => { },
      onSubmit: () => { },
      title: 'tws.reference-pain-scale-value',
      uuid: generateUUID(),
    };

    modalProperties.contextData = {
      scoreType,
    }

    ModalService.openFullscreen(modalProperties);
  }

  private getRadioGroupArray(): RadioGroupData[] {
    return [{ field: this.radioGroupMonitoringControlA, props: RadioGroupExpressions.DS_ITEM_1A }, { field: this.radioGroupMonitoringControlB, props: RadioGroupExpressions.DS_ITEM_1B },
      { field: this.radioGroupMonitoringControlC, props: RadioGroupExpressions.DS_ITEM_1C }, { field: this.radioGroupLaboratory, props: RadioGroupExpressions.DS_ITEM_2 }, { field: this.radioGroupMedication, props: RadioGroupExpressions.DS_ITEM_3 },
      { field: this.radioGroupHygieneA, props: RadioGroupExpressions.DS_ITEM_4A }, { field: this.radioGroupHygieneB, props:RadioGroupExpressions.DS_ITEM_4B }, { field: this.radioGroupHygieneC, props: RadioGroupExpressions.DS_ITEM_4C },
      { field: this.radioGroupDrain, props: RadioGroupExpressions.DS_ITEM_5 }, { field: this.radioGroupMobilityA, props: RadioGroupExpressions.DS_ITEM_6A }, { field: this.radioGroupMobilityB, props: RadioGroupExpressions.DS_ITEM_6B },
      { field: this.radioGroupMobilityC, props: RadioGroupExpressions.DS_ITEM_6C }, { field: this.radioGroupSupportA, props: RadioGroupExpressions.DS_ITEM_7A }, { field: this.radioGroupSupportB, props: RadioGroupExpressions.DS_ITEM_7B },
      { field: this.radioGroupAdminTasksA, props: RadioGroupExpressions.DS_ITEM_8A}, { field: this.radioGroupAdminTasksB, props: RadioGroupExpressions.DS_ITEM_8B }, { field: this.radioGroupAdminTasksC, props: RadioGroupExpressions.DS_ITEM_8C },
      { field: this.radioGroupSupportVentilatoryA, props: RadioGroupExpressions.DS_ITEM_9 },{ field: this.radioGroupSupportVentilatoryB, props: RadioGroupExpressions.DS_ITEM_10 },
      { field: this.radioGroupSupportVentilatoryC, props: RadioGroupExpressions.DS_ITEM_11 }, { field: this.radioGroupSupportCardioA, props: RadioGroupExpressions.DS_ITEM_12 }, { field: this.radioGroupSupportCardioB, props: RadioGroupExpressions.DS_ITEM_13 },
      { field: this.radioGroupSupportCardioC, props: RadioGroupExpressions.DS_ITEM_14 }, { field: this.radioGroupSupportCardioD, props: RadioGroupExpressions.DS_ITEM_15 }, { field: this.radioGroupRenalSupportA, props: RadioGroupExpressions.DS_ITEM_16 },
      { field: this.radioGroupRenalSupportB, props: RadioGroupExpressions.DS_ITEM_17 }, { field: this.radioGroupNeurologicSupport, props: RadioGroupExpressions.DS_ITEM_18 },
      { field: this.radioGroupMetabolicSupportA, props: RadioGroupExpressions.DS_ITEM_19 }, { field: this.radioGroupMetabolicSupportB, props: RadioGroupExpressions.DS_ITEM_20 }, { field: this.radioGroupMetabolicSupportC, props: RadioGroupExpressions.DS_ITEM_21 },
      { field: this.radioGroupSpecialIntervetionsA, props: RadioGroupExpressions.DS_ITEM_22 }, { field: this.radioGroupSpecialIntervetionsB, props: RadioGroupExpressions.DS_ITEM_23 }];
  }

  @OnClick({ target: ScoreNasEditAliases.ACTION_NEW_SCORE_NAS })
  handleClickNew(): void {
    const { encounterId, patientId } = this.historyService.getCurrentRouteParams();
    applicationContext.popNavigationItem();
    applicationContext.redirect(ApplicationRoute.SCORE_NAS_CREATE, {
      encounterId,
      patientId,
    })
  }

  @OnClick({ target: ScoreNasEditAliases.ACTION_RELEASE_SCORE_NAS })
  handleClickRelease(): void {
    const { idScoreIndexes } = this.historyService.getCurrentRouteParams();
    this.showModalSubmit(idScoreIndexes as number);
  }

  @OnClick({ target: ScoreNasEditAliases.ACTION_DELETE_SCORE_NAS })
  handleClickDelete(): void {
    const { idScoreIndexes } = this.historyService.getCurrentRouteParams();
    this.confirmDelete(idScoreIndexes as number);
  }

  @OnClick({ target: ScoreNasEditAliases.ACTION_REFERENCE_SCORE_NAS })
  handleClickReference(): void {
    this.getReference();
  }

  @OnUnmount(ScoreNasEditAliases.SCORE_NAS_ADD_LAYOUT)
  handleUnmount(): void {
    ScoreListContext.clean();
    ScoreListContext.currentTab = ScoreType.SCORE_NAS;
  }
}
